module.exports = __webpack_public_path__ + "assets/img/nature-time-bg-6.eb266265.png";